import React, { useState, useEffect } from 'react';
import { OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { faPlus, faMinus } from '@fortawesome/pro-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import {
  useGetPublicAssignmentNodesMutation,
  useSetImportPublicAssignmentsMutation
} from '../../../../features/authentication/assignmentApislice';
import TreeView from 'react-accessible-treeview';
import AssignmentFloatingBar from '../../../../components/FloatingBar';
import '../../../../components/floatingMenu/floatingMenu.scss';
import HesSpinner from '../../../../components/loadingOverlay/hesSpinner';
import CustomToast from '../../../../components/Toast';
import PublicSetPreviewModal from './Components/modals/PublicSetPreviewModal';

const CreatePublicAssignment = () => {
  const navigate = useNavigate();
  const [parentNodes, setParentNodes] = useState([]);
  const [parentNodesCount, setParentNodeCount] = useState(0);
  const [getPublicAssignmentNodes] = useGetPublicAssignmentNodesMutation();
  const [setImportPublicAssignments] = useSetImportPublicAssignmentsMutation();
  const [isExpand, setIsExpand] = useState(false);
  const [selectedNodes, setSelectedNodes] = useState([]);
  const [selectedTreeNodes, setSelectedTreeNodes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [viewPublicSetModal, setViewPublicSetModal] = useState(false);
  const [viewPublicSetTitle, setViewPublicSetTitle] = useState();
  const [selectedPublicAssignmentId, setSelectedPublicAssignmentId] = useState('');

  useEffect(() => {
    getPublicAssignmentNodesHandler('', 'root');
  }, []);

  const getPublicAssignmentNodesHandler = async (rootName, nodeValue) => {
    let option = { node: nodeValue };
    try {
      if (
        nodeValue.startsWith('Castle_Assignments') ||
        nodeValue.startsWith('District_Assignments') ||
        /^\d+$/.test(nodeValue)
      ) {
        let newNode = parentNodes
          .find((item) => item.id == rootName)
          .childrens.find((item1) => item1.id == nodeValue).childrens;
        if (
          !parentNodes
            .find((item) => item.name == rootName)
            .childrens.some((item2) => item2.id == newNode[0].id)
        )
          setParentNodes((prevData) => {
            return prevData.map((item) => {
              if (item.name === rootName) {
                let updatedChildrens = item.childrens.map((child) => {
                  if (child.id == nodeValue) {
                    return {
                      ...child,
                      children: [
                        ...(child.children || []),
                        ...newNode.map((newNodeItem) => newNodeItem.id)
                      ]
                    };
                  }
                  return child;
                });
                updatedChildrens = [...updatedChildrens, ...newNode];
                return { ...item, childrens: updatedChildrens };
              }
              return item;
            });
          });
      } else {
        const response = await getPublicAssignmentNodes(option).unwrap();
        if (nodeValue == 'root') {
          setParentNodes(response);
          setParentNodeCount(response.length);
          setIsLoading(false);
        } else {
          const newIds = response.map((newItem) => newItem.id);
          if (
            !parentNodes
              .find((i) => i.name == rootName)
              .childrens.some((item2) => item2.id == newIds[0])
          )
            setParentNodes((prevData) => {
              return prevData.map((item) => {
                if (item.name === rootName) {
                  const updatedChildrens = item.childrens.map((child) => {
                    if (child.id == nodeValue) {
                      return { ...child, children: newIds };
                    }
                    return child;
                  });
                  return { ...item, childrens: [...updatedChildrens, ...response] };
                }
                return item;
              });
            });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleParentClick = (children, event, index) => {
    if (!selectedNodes.some((node) => node?.id === event.currentTarget.id)) {
      let newNode = { id: event.currentTarget.id };
      let newSelectedNodes = [...selectedNodes];
      newSelectedNodes = Array.from({ length: parentNodesCount }, (_, i) => ({
        id: i < selectedNodes.length ? selectedNodes[i].id : ''
      }));
      newSelectedNodes[index] = { id: newNode.id };
      setSelectedNodes(newSelectedNodes);
    } else {
      setSelectedNodes((prevNodes) =>
        prevNodes.map((item, i) => ({
          id: i === index ? '' : item.id
        }))
      );
    }
    setIsExpand(!isExpand);
  };

  const handleChildClick = (rootName, nodeValue, isExpanded) => {
    if (!isExpanded) getPublicAssignmentNodesHandler(rootName, nodeValue);
  };

  const handleCheckboxSelect = (event) => {
    const nodeId = event.target.id;
    const treeNode = selectedTreeNodes;

    if (!treeNode.includes(nodeId)) {
      const updatedTreeNodes = [...treeNode, nodeId];
      setSelectedTreeNodes(updatedTreeNodes);
    } else {
      const updatedTreeNodes = treeNode.filter((id) => id !== nodeId);
      setSelectedTreeNodes(updatedTreeNodes);
    }
  };

  const handleButtonClick = async () => {
    if (selectedTreeNodes.length > 0) {
      let option = {
        publicAssignmentIds: selectedTreeNodes
      };
      setIsLoading(true);
      const response = await setImportPublicAssignments(option).unwrap();
      if (response.isSuccess) {
        setIsLoading(false);
        CustomToast('Assignment Import Successful!', 'success');
        navigate('/assignments');
      } else {
        setIsLoading(false);
        CustomToast('Assignment Import Failed!', 'error');
      }
    } else {
      CustomToast('You need to check at least one Public Assignment to Import!', 'error');
    }
  };

  const viewPublicSetHandler = (event, title) => {
    const titleId = event.target.id;
    if (!isLoading) {
      setViewPublicSetModal(true);
      setSelectedPublicAssignmentId(titleId);
      setViewPublicSetTitle(title);
    }
  };

  return (
    <>
      <div className="white-card">
        <div className="d-flex justify-content-between">
          <h2 className="align-items-center d-flex gap-2 primary-title">
            Import Public Assignment
            <OverlayTrigger
              key={'assignment-options'}
              placement="right"
              overlay={
                <Tooltip className="additional-options-tooltip">
                  <p>
                    Select one or more public assignments and click import to create a new
                    assignment from the selected assignments.
                  </p>
                </Tooltip>
              }>
              <FontAwesomeIcon className="circle-question" icon={faCircleQuestion} />
            </OverlayTrigger>
          </h2>
          <div>
            <button
              id="back_button"
              onClick={() => navigate('/assignments')}
              className="btn btn-castleWhite btn-width">
              Back
            </button>
          </div>
        </div>
        {!isLoading ? (
          <>
            <div className="d-flex row justify-content-between pt-3">
              {parentNodes.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`assignments-card p-2 col-4 cursor-pointer ${
                      index % 3 === 0 ? 'clear-row' : ''
                    }`}>
                    <div className="select-questions">
                      <div
                        id={item.name}
                        className="d-flex align-items-center"
                        onClick={(e) => handleParentClick(item.childrens, e, index)}>
                        <div className="align-items-center d-flex icon-div justify-content-center m-2">
                          <FontAwesomeIcon
                            icon={
                              selectedNodes.find((node) => node.id === item.name) ? faMinus : faPlus
                            }
                            className="icon"
                          />
                        </div>
                        <div>{item.name}</div>
                      </div>
                      {selectedNodes.find((node) => node.id === item.name) && (
                        <>
                          <TreeView
                            data={item.childrens}
                            aria-label="Checkbox tree"
                            multiSelect
                            propagateSelect
                            propagateSelectUpwards
                            togglableSelect
                            nodeRenderer={({
                              element,
                              isBranch,
                              isExpanded,
                              isSelected,
                              isHalfSelected,
                              getNodeProps,
                              handleExpand
                            }) => {
                              return (
                                <>
                                  <div {...getNodeProps({ onClick: handleExpand })}>
                                    {isBranch && (
                                      <>
                                        <div
                                          onClick={() =>
                                            handleChildClick(item.name, element.id, isExpanded)
                                          }>
                                          <div className="icon-div p-1 mb-2 margin-left-20">
                                            <FontAwesomeIcon
                                              icon={isExpanded ? faMinus : faPlus}
                                              className="icon"
                                              isOpen={isExpanded}
                                            />
                                          </div>

                                          <span id={element.id} className="name">
                                            {element.name}
                                          </span>
                                        </div>
                                      </>
                                    )}

                                    {!isBranch && (
                                      <div className="d-flex">
                                        <Form.Check
                                          id={element.id}
                                          type="checkbox"
                                          className="checkbox-name margin-left-20"
                                          onClick={(e) => {
                                            handleCheckboxSelect(e);
                                            e.stopPropagation();
                                          }}
                                          variant={
                                            isHalfSelected ? 'some' : isSelected ? 'all' : 'none'
                                          }
                                        />
                                        <span
                                          id={element.id}
                                          onClick={(e) => viewPublicSetHandler(e, element.name)}
                                          className="linkto m-2 mb-1 mt-0">
                                          {element.name}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </>
                              );
                            }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="floating-menu">
              <AssignmentFloatingBar
                content={
                  'Select one or more public assignments and click <strong>import</strong> to create a new assignment from the selected assignments.'
                }
                buttonText={'Import'}
                handleButtonClick={handleButtonClick}
              />
            </div>
          </>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: '40px' }}>
            <HesSpinner />
            <span className="ms-3">Loading results...</span>
          </div>
        )}
      </div>

      <PublicSetPreviewModal
        viewPublicSetModal={viewPublicSetModal}
        viewPublicSetTitle={viewPublicSetTitle}
        onClose={()=>setViewPublicSetModal(false)}
        showPrintButton={false}
        selectedPublicAssignmentId={selectedPublicAssignmentId}
      />
    </>
  );
};

export default CreatePublicAssignment;
